import { PermissionsActions } from '@permissions/permissions.types'

const resourceRegex = /(?<permission>(\w(-\w)*)+:(\w([.-]\w)*)+)/.source
const actionRegex = /(?::(?<action>(create|read|update|delete)))?/.source

const permissionRegex = new RegExp(`${resourceRegex}${actionRegex}`)

// TODO: replace [key: string] with [key in PermissionResources] after adding a resources
export const ResourcesScopes: { [key: string]: string } = {}

export const ActionScopes: { [key in PermissionsActions]: string } = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
}

const parsePermissionAction = (value: string) => {
  const matchGroups = value.match(permissionRegex)?.groups
  return {
    resource: matchGroups?.action ? matchGroups?.permission : value,
    action: matchGroups?.action ?? null,
  }
}

const comparePermissions = (request: string, permission: string): boolean => {
  const permissionParts = parsePermissionAction(permission)
  const requestParts = parsePermissionAction(request)

  const isResourceValid = requestParts.resource.includes(permissionParts.resource)
  const isActionValid = !permissionParts.action || permissionParts.action === requestParts.action

  return isResourceValid && isActionValid
}

export const isAllowed = (request: string, permissions: string[]): boolean => {
  return permissions.some(permission => comparePermissions(request, permission))
}
